(function () {
  let activeTouchCard = null;
  let autoResetTimer = null;
  let touchStartY = 0;
  let touchStartX = 0;
  let isScrolling = false;

  function getSlideshow(cardEl) {
    return cardEl.refs?.slideshow || null;
  }

  function resetToFirst(cardEl) {
    const slideshow = getSlideshow(cardEl);
    if (!slideshow) return;
    const firstSlide = slideshow.slides?.[0];
    if (!firstSlide) return;
    const slideId = firstSlide.getAttribute('slide-id');
    if (slideId) slideshow.select({ id: slideId }, undefined, { animate: false });
  }

  function showSecondImage(cardEl) {
    const slideshow = getSlideshow(cardEl);
    if (!slideshow) return;
    const secondSlide = slideshow.slides?.[1];
    if (!secondSlide) return;
    const slideId = secondSlide.getAttribute('slide-id');
    if (slideId) slideshow.select({ id: slideId }, undefined, { animate: false });
  }

  function handleTouchStart(event) {
    touchStartY = event.touches[0].clientY;
    touchStartX = event.touches[0].clientX;
    isScrolling = false;

    const cardEl = event.currentTarget.closest('product-card');
    if (!cardEl) return;

    const slideshow = getSlideshow(cardEl);
    if (!slideshow || !slideshow.slides || slideshow.slides.length < 2) return;

    if (activeTouchCard && activeTouchCard !== cardEl) {
      resetToFirst(activeTouchCard);
      clearTimeout(autoResetTimer);
      autoResetTimer = null;
    }

    activeTouchCard = cardEl;
    showSecondImage(cardEl);

    if (autoResetTimer) clearTimeout(autoResetTimer);
    autoResetTimer = setTimeout(() => {
      if (activeTouchCard === cardEl) {
        resetToFirst(cardEl);
        activeTouchCard = null;
      }
    }, 3000);
  }

  function handleTouchMove(event) {
    const deltaY = Math.abs(event.touches[0].clientY - touchStartY);
    const deltaX = Math.abs(event.touches[0].clientX - touchStartX);

    // Agar vertical scroll zyada hai toh scroll hone do
    if (deltaY > deltaX && deltaY > 10) {
      isScrolling = true;
      if (activeTouchCard) {
        resetToFirst(activeTouchCard);
        activeTouchCard = null;
        clearTimeout(autoResetTimer);
      }
    }
  }

  function attachTouchListeners() {
    const galleries = document.querySelectorAll('.card-gallery');
    galleries.forEach((gallery) => {
      if (gallery.dataset.touchAttached) return;
      gallery.dataset.touchAttached = 'true';
      gallery.addEventListener('touchstart', handleTouchStart, { passive: true });
      gallery.addEventListener('touchmove', handleTouchMove, { passive: true });
    });
  }

  document.addEventListener('DOMContentLoaded', attachTouchListeners);

  const observer = new MutationObserver(attachTouchListeners);
  observer.observe(document.body, { childList: true, subtree: true });
})();
